import { defaultReportFilter } from '@/configs/main';
import {
	getCurrentMerchant,
	getCurrentBranch,
	getSubscriptions,
	getAssignedLicenses,
	getReportFilter,
	getBranchIds,
} from '@/helpers/WorkspaceHelper';
import {
	CHANGE_MERCHANT,
	CHANGE_BRANCH,
	CHANGE_BRANCH_IDS,
	CHANGE_SUBSCRIPTIONS,
	CHANGE_ASSIGNED_LICENSES,
	CLEAR_WORKSPACE,
	CHANGE_REPORT_FILTERS,
} from '../actions-registry';

const INIT_STATE = {
	merchant: getCurrentMerchant(),
	branch: getCurrentBranch(),
	branchIds: getBranchIds(),
	subscriptions: getSubscriptions(),
	assignedLicenses: getAssignedLicenses(),
	reportFilter: getReportFilter(),
};

export default (state = INIT_STATE, action) => {
	switch (action.type) {
		case CHANGE_MERCHANT:
			return { ...state, merchant: action.payload };
		case CHANGE_BRANCH:
			return { ...state, branch: action.payload };
		case CHANGE_BRANCH_IDS:
			return { ...state, branchIds: action.payload };
		case CHANGE_SUBSCRIPTIONS:
			return { ...state, subscriptions: action.payload };
		case CHANGE_ASSIGNED_LICENSES:
			return { ...state, assignedLicenses: action.payload };
		case CHANGE_REPORT_FILTERS:
			return { ...state, reportFilter: action.payload };
		case CLEAR_WORKSPACE:
			return {
				...state,
				branch: { branchId: '*', branchName: 'All' },
				branchIds: '',
				merchant: null,
				subscriptions: [],
				assignedLicenses: [],
				reportFilter: defaultReportFilter,
			};
		default:
			return { ...state };
	}
};
